import * as React from "react";
import { Carousel } from "@grandvisionhq/common";
import { Measurement } from "../../../../../../Measurement/modules/SecondaryProductInfo/FrameMeasurements/components/Measurement/Measurement.js";
const MeasurementCarousel = ({ measurements }) => {
  return /* @__PURE__ */ React.createElement(Carousel, { hasPagination: true }, measurements.map((item) => /* @__PURE__ */ React.createElement(Measurement, { ...item, key: item.key })));
};
export {
  MeasurementCarousel
};
//# sourceMappingURL=MeasurementCarousel.js.map
